import { createFileRoute } from "@tanstack/react-router"

import { TermsPage } from "@/pages/(guest)/terms/page"

export const Route = createFileRoute("/_guest/terms")({
  component: TermsPage,
})
